import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import './index.css'
import "vnetwork-player/dist/vnetwork-player.min.css" // import css
import "react-toastify/dist/ReactToastify.css";
import 'react-quill/dist/quill.snow.css';
import { ToastContainer } from "react-toastify";
import 'swiper/css';
import 'swiper/css/navigation';
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>,
)
